"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_MEDIA_TYPES = void 0;
exports.DATA_MEDIA_TYPES = [
    'application/json',
    'text/csv',
    'text/tab-separated-values',
    'text/markdown',
    'text/plain',
];
